import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { rootUrl, formatDate, formatToZMW } from '../../../helpers'
import { useAuth } from '../../../context/auth-context'
import { toast } from 'react-toastify';
import { FaSpinner } from 'react-icons/fa';
import Select from 'react-select';

export default function BillReport({startDate, endDate}) {

    const auth = useAuth();
    const [bills, setBills] = useState([])
    const [filtered, setFiltered] = useState([])
    const [loading, setLoading] = useState(true)

    const fetchData = async () =>{
        try{
            const data =  await axios.get(rootUrl(`/getBillsDate/${auth.user.cid}~${startDate}~${endDate}`))
            setBills(data.data.data)
            setFiltered(data.data.data)
            setLoading(false)
        }catch(e){
            toast.error(e?.message)
        }
        
    }


    useEffect(()=>{
        fetchData()
    },[])

   const filterLocation = (location) =>{
  
    if(location === '' || location === undefined){
      setFiltered(bills)
    }else{
      setFiltered(bills.filter(a=>a.location === location))
    }
  
   }

   const locationOptions = [...new Set(bills.map(a => a.location))]
    .map(location => ({ value: location, label: location }));

  return (
    <div>
      

{loading?
    <div className='flex justify-center items-center h-full w-full text-blue-950 text-5xl p-5 m-5 '>
                  <FaSpinner size={50} className="spinner"  /> 
                </div>:
                <>
             <Select
      options={locationOptions}
      onChange={(selectedOption) => filterLocation(selectedOption?.value)}
      placeholder="Filter location"
      isClearable
      className="w-[500px]"
    />

<h2 className='font-bold text-2xl my-2'>Bills</h2>
               
    <TableComponent data={filtered} />
                </>

}
    </div>
  )
}

const TableComponent = ({ data }) => {
  const columns = [
    { name: "Sn", selector: (row, index) => index + 1 },
    { name: "Property", selector: (row) => row?.property_no },
    { name: "Customer", selector: (row) => `${row?.name}` },
    { name: "Description", selector: (row) => `${row?.description}` },
    { name: "Location", selector: (row) => row?.location },
    { name: "Bill", selector: (row) => formatToZMW(parseFloat(row.tt) || 0) },
    { name: "Receipt", selector: (row) => formatToZMW(parseFloat(row.tr) || 0) },
    { name: "Outstanding", selector: (row) => formatToZMW(parseFloat(row.amount) || 0) },
  ];

  const totalBill = data.reduce((sum, row) => sum + (parseFloat(row.tt) || 0), 0);
  const totalReceipt = data.reduce((sum, row) => sum + (parseFloat(row.tr) || 0), 0);
  const totalOutstanding = data.reduce((sum, row) => sum + (parseFloat(row.amount) || 0), 0);

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full border border-gray-300">
        <thead>
          <tr className="bg-blue-950 text-white border-b">
            {columns.map((col, index) => (
              <th key={index} className="py-2 px-4 text-left border-r">{col.name}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={row.id} className="border-b hover:bg-gray-50">
              {columns.map((col, colIndex) => (
                <td key={colIndex} className="py-2 px-4 border-r">
                  {col.selector(row, rowIndex)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
        {/* Totals Row */}
        <tfoot>
          <tr className="bg-gray-200 font-bold">
            <td colSpan="5" className="py-2 px-4 text-right border-r">Total</td>
            <td className="py-2 px-4 border-r">{formatToZMW(totalBill)}</td>
            <td className="py-2 px-4 border-r">{formatToZMW(totalReceipt)}</td>
            <td className="py-2 px-4">{formatToZMW(totalOutstanding)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

  
